"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const axios_1 = __importDefault(require("axios"));
class Subscription extends base_1.default {
    subscribe(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'post',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription`,
            data: data,
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    unsubscribe(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'delete',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription`,
            data: data,
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    getInvoices(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'get',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription/invoices`,
            data: data,
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    getSubscription(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'get',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription`,
            data: data,
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    getLawFirmData(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'get',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription/law-firm-data`,
            data: {},
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
    getUpcomingCharge(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'get',
            url: `${window.AppearMe.appConfigs.CRMApiUrl}/subscription/upcoming-charge`,
            data: {},
            headers: {
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            responseType: 'json'
        });
    }
}
exports.default = new Subscription();
